/**
 * Flatten a property filter's selection to string system-names, tolerant of shape.
 *
 * The canonical shape is `values: string[]` for `in`/`not_in` and a scalar
 * `value` for single-value operators. This reader also tolerates a scalar in
 * `values` and — importantly — an array left in `value` by older buggy rows, so
 * summary/label readers never call `.replace` on a non-string and crash.
 *
 * `values` wins when present (non-empty); otherwise falls back to `value`.
 * Non-string entries are dropped.
 */
export function readFilterStringValues(f: {
  value?: unknown;
  values?: unknown;
}): string[] {
  const collect = (v: unknown): string[] =>
    (Array.isArray(v) ? v : [v]).filter(
      (x): x is string => typeof x === 'string' && x.length > 0
    );

  const fromValues = collect(f.values);
  return fromValues.length > 0 ? fromValues : collect(f.value);
}
